// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"8aebe197","809":"2ccab9ef"}[chunkId] + ".chunk.js";
};